<template>
  <q-btn
    outline
    size="0"
    padding="0"
    :rounded="onlyIcon"
    :color="disabled ? 'blue-grey-4' : color"
    @click="handleClick"
    :class="['q-ma-xs q-px-sm', onlyIcon ? 'min-width-40 q-py-xs' : 'min-width-75 q-pb-md']"
    :disable="disabled"
  >
    <div
      :class="['column items-center', onlyIcon ? 'items-end content-end flex-end justify-end' : '']"
      :style="onlyIcon ? 'height: 30px' : 'height: 60px'"
    >
      <div
        v-if="$scopedSlots['icon']"
        class="col"
      >
        <div class="row full-height items-center ">
          <slot name="icon" />
        </div>
      </div>

      <div
        v-if="label && !onlyIcon"
        class="col-auto control-label"
        v-html="label"
      />
    </div>

    <slot />

    <q-tooltip
      :content-class="`bg-${color}`"
      v-if="!disabled && tooltip"
    >
      <span v-if="!tooltip.includes('<')">
        {{ tooltip }}
      </span>
      <div
        v-else
        v-html="tooltip"
      />
    </q-tooltip>
  </q-btn>
</template>

<script>
export default {
  props: {
    label: String,
    tooltip: String,
    disabled: Boolean,
    onlyIcon: {
      type: Boolean,
      default: true
    },

    color: {
      type: String,
      default: 'grey-10'
    }
  },

  methods: {
    handleClick () {
      this.$emit('on-click')
    }
  }
}
</script>

<style lang="sass" scoped>
.control-label
  font-style: normal
  font-weight: 300
  font-size: 10px
  line-height: 10px

.min-width-75
  width: 75px
  min-width: 75px

.min-width-40
  width: 40px
  min-width: 40px
</style>
